module.exports = __webpack_public_path__ + "static/media/ser_saf_fil.4bcea54c.png";